export const getFbString = (targetData: any) => {
    let experimentStringFB = '';
    if (targetData?.fetching === false) {
        const fbExperiments = targetData?.data?.execute?.mboxes;
        if (fbExperiments) {
            fbExperiments.forEach((experiment: any) => {
                const activityName = experiment?.options?.[0]?.responseTokens?.['activity.name'];
                const experienceName = experiment?.options?.[0]?.responseTokens?.['experience.name'];
                if (activityName && experienceName) {
                    const newExperimentString = `${activityName} ${experienceName}, `;
                    if (!experimentStringFB.includes(newExperimentString)) experimentStringFB += newExperimentString;
                }
            });
            experimentStringFB = experimentStringFB.replace(/,\s*$/, '');
        }
    }
    return experimentStringFB;
};

export const getVcString = (targetData: any) => {
    let experimentStringVC = '';
    if (targetData?.fetching === false) {
        const vcExperiments = targetData?.data?.execute?.pageLoad?.options;
        if (vcExperiments) {
            targetData?.data?.execute?.pageLoad?.options.forEach((experiment: any) => {
                const activityName = experiment?.responseTokens?.['activity.name'];
                const experienceName = experiment?.responseTokens?.['experience.name'];
                if (activityName && experienceName) {
                    const newExperimentString = `${activityName} ${experienceName}, `;
                    if (!experimentStringVC.includes(newExperimentString)) experimentStringVC += newExperimentString;
                }
            });
            experimentStringVC = experimentStringVC.replace(/,\s*$/, '');
        }
    }
    return experimentStringVC;
};

export const getFullExperimentString = (targetData: any) => {
    const fbString = getFbString(targetData);
    const vcString = getVcString(targetData);
    const AdobeExperiment = (fbString + ' ' + vcString).trim();

    return AdobeExperiment === '' ? undefined : AdobeExperiment;
};
